function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// src/components/breadcrumb.ts
import { breadcrumbAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, cssVar, defineStyle } from "@chakra-ui/styled-system";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig,
  definePartsStyle = _createMultiStyleConf.definePartsStyle;
var $decor = cssVar("breadcrumb-link-decor");
var baseStyleLink = defineStyle(_defineProperty(_defineProperty({
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  outline: "none",
  color: "inherit",
  textDecoration: $decor.reference
}, $decor.variable, "none"), "&:not([aria-current=page])", {
  cursor: "pointer",
  _hover: _defineProperty({}, $decor.variable, "underline"),
  _focusVisible: {
    boxShadow: "outline"
  }
}));
var baseStyle = definePartsStyle({
  link: baseStyleLink
});
var breadcrumbTheme = defineMultiStyleConfig({
  baseStyle: baseStyle
});
export { breadcrumbTheme };